module.exports = __webpack_public_path__ + "media/images/web/banner_scenic_arts-f8fc104eb7cc438311d59520371baea9.png";